export { default } from './Home24HeroSemanaCliente';
